// Package imports:
import React from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

export type LabelTypes = 'active' | 'disabled';
interface IProps {
    active: boolean,
};

const GeniusLabel: React.FC<IProps> = ({ active }) => {
    let text = "Virkur";
    if (!active) text = "Óvirkur";
    return (
        <div className={cx("KCL_geniusLabel", { inActive: !active })}>
            <FontAwesomeIcon className="fa-icon" icon={faCircle} />
            <span className="geniusLabel-text">{text}</span>
        </div>
    );
};

export default GeniusLabel;

